import { BarChart2, Sparkles, Users, TrendingUp, Gauge, ShieldCheck } from "lucide-react";

const services = [
  {
    icon: <BarChart2 size={32} className="text-blue-600" />,
    title: "Plateforme IA",
    description: "Une plateforme d’IA dédiée à LinkedIn, pour une analyse actionnable et sur-mesure.",
  },
  {
    icon: <Sparkles size={32} className="text-blue-600" />,
    title: "Recommandations intelligentes",
    description: "Des conseils ciblés selon vos objectifs et les benchmarks de votre secteur.",
  },
  {
    icon: <Users size={32} className="text-blue-600" />,
    title: "Conseil humain",
    description: "Un accompagnement stratégique par des experts pour affiner votre impact.",
  },
  {
    icon: <TrendingUp size={32} className="text-blue-600" />,
    title: "Visibilité accrue",
    description: "Optimisation de votre contenu pour capter plus d’audience qualifiée.",
  },
  {
    icon: <Gauge size={32} className="text-blue-600" />,
    title: "Efficacité mesurable",
    description: "Suivi de performance avec KPIs clairs pour ajuster vos campagnes.",
  },
  {
    icon: <ShieldCheck size={32} className="text-blue-600" />,
    title: "Avantage concurrentiel",
    description: "Comparez-vous aux leaders du marché et prenez une longueur d'avance.",
  },
];


const ServicesSection = () => {
  return (
    <section className="bg-white dark:bg-dark py-20">
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center">
          <h2 className="text-4xl font-bold text-dark dark:text-white">
            Nos Services
          </h2>
          <p className="mt-4 text-lg text-gray-600 dark:text-gray-400 max-w-xl mx-auto">
            AmplifyMyCom allie la puissance de l’IA et l’intelligence humaine pour amplifier votre impact sur LinkedIn.
          </p>
        </div>
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, index) => (
            <div
              key={index}
              className="rounded-xl bg-gray-50 dark:bg-gray-800 p-6 shadow hover:shadow-md transition"
            >
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
                {service.icon}
              </div>
              <h3 className="mb-2 text-xl font-semibold text-dark dark:text-white">
                {service.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-300">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
